/** @jsx h */
import { h, Component, Fragment } from 'preact';
import { connect } from 'react-redux';
import {
  getStorageLenderId,
  lenderTheme,
  storeLenderId,
} from '../utils/lenderTheme';
import { Container } from './partial';
import SnackBar from './partial/layers/snackBar';
import onAppInit from '../actions/onAppInit';
import actionType from '../actions/onAppInit/actionType';
import Utils from '../utils';
import Modal from './partial/layers/modals';
import { instacredHomeRoutes } from '../alias/homeRoutes';
import Spinner from './spinner/spinner';
import { createGlobalStyles } from 'goober/global';

const GlobalStyles = createGlobalStyles`
  html,
  body{
    background:  ${(props) =>
      props.template &&
      !(props.template === 'checkoutWidget' || props.template === 'salesApp')
        ? '#eeecec'
        : 'transparent'};
  }
`;

class AppContainer extends Component {
  pageKey = 'AppContainer';

  spinnerStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  };

  componentDidMount() {
    const url = window.location.hostname.split('.')[0];
    const lenderDetails = Object.keys(lenderTheme).filter((lenderId) => {
      return url.includes(lenderTheme[lenderId].subDomainName);
    });
    /**
     * getting lenderId here
     * priority is subDomain => lenderId from localstorage => default(instaCred)
     * @type {string | string}
     */
    const lenderId = lenderDetails[0] || getStorageLenderId() || '';
    if (!Utils.isOrganicSite()) {
      storeLenderId(lenderId);
    }
    const themeName = lenderTheme[lenderId];
    this.props.onAppInit(actionType.initialize, {
      lenderDetails: { ...themeName, id: lenderId },
    });
  }

  componentDidUpdate(previousProps) {
    let { template, lenderId } = this.props || {};
    const { template: prevTemplate, lenderId: prevLenderId } =
      previousProps || {};

    const isOrganicSite = Utils.isOrganicSite();

    if (lenderId === '') {
      const lenderDetails = Utils.getLenderIdsFromSubDomain();
      lenderId = lenderDetails[0] || getStorageLenderId() || '';
      if (!Utils.isOrganicSite()) {
        storeLenderId(lenderId);
      }
    }

    if (
      (lenderId && lenderId !== prevLenderId) ||
      (template && template !== prevTemplate)
    ) {
      if (lenderId && lenderId !== prevLenderId) {
        if (!Utils.isOrganicSite()) {
          storeLenderId(lenderId);
        }
      }
      this.onAction(actionType.updateTemplate, { template });
      if (lenderTheme[lenderId]) {
        isOrganicSite
          ? this.updateTheme(lenderTheme['instaCred'].theme)
          : this.updateTheme(lenderTheme[lenderId].theme);
      } else {
        this.updateTheme(lenderTheme['instaCred'].theme);
      }
    }
  }

  updateTheme = (theme) => {
    const { template } = this.props;
    if (
      template === 'payment' ||
      template === 'common' ||
      template === 'widget' ||
      template === 'neutral'
    ) {
      return Utils.applyLenderTheme('instaCred');
    }
    Utils.applyLenderTheme(theme || this.props.theme);
  };

  onAction = (actionType, ...rest) => {
    this.props.onAppInit(actionType, ...rest);
  };

  render() {
    let { template } = this.props || {};
    return (
      <Fragment>
        <GlobalStyles template={template} />
        <SnackBar />
        <Modal />
        {/*{this.isComponentVisible() ? (*/}
        <Container>{this.props.children}</Container>
        {/*) : (*/}
        {/*  <Spinner style={this.spinnerStyle} />*/}
        {/*)}*/}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ registrationUserData, config, identifyUser }) => {
  const { lenderDetails } = config;
  const { theme } = lenderDetails;
  const { lenderId } = registrationUserData;
  const { isGuest, apiState } = identifyUser || {};
  return {
    lenderId,
    theme,
    apiState,
    isGuest,
  };
};

export default connect(
  mapStateToProps,
  { onAppInit },
)(AppContainer);



// WEBPACK FOOTER //
// ./components/appContainer.js